import React, { useState } from "react";
import VerificationComplete from "./VerificationComplete";
import VerificationFormContainer from "./VerificationFormContainer";
import { translate } from "@kaltura/mediaspace-shared-utils";
import VerificationProps from "./VerificationProps";
import { BodyText, InnerContainer, Title, Wrapper } from "@kaltura/mediaspace-shared-ui";
import { CaptchaDisclaimer } from "@kaltura/mediaspace-shared-ui";
/**
 * Component to handle email verification during site registration process
 */
export function Verification({
    recaptchaSiteKey,
    recaptchaTheme = "light",
    recapthcaMode,
    completeTitle,
    completeDescriptionHtml,
    submitUrl,
}: VerificationProps) {
    const [sent, setSent] = useState(false);

    const handleSubmit = () => {
        setSent(true);
    };

    return (
        <Wrapper className="siteRegistration">
            <InnerContainer className="kms-ds-registration-verification-content">
                {sent && (
                    <VerificationComplete
                        completeTitle={completeTitle}
                        completeDescriptionHtml={completeDescriptionHtml}
                    />
                )}
                {!sent && (
                    <>
                        <Title variant={"h2"} component={"h1"} className="siteRegistration-complete-title">
                            {translate("Send Activation Email")}
                        </Title>
                        <BodyText align={"center"} variant={"body1"}>
                            {translate("Enter your email address to resend the activation email.")}
                        </BodyText>
                        <div>
                            <VerificationFormContainer
                                recaptchaSiteKey={recaptchaSiteKey}
                                recaptchaTheme={recaptchaTheme}
                                recapthcaMode={recapthcaMode}
                                onSubmit={handleSubmit}
                                submitUrl={submitUrl}
                            />
                        </div>
                    </>
                )}
            </InnerContainer>
            {recapthcaMode && recapthcaMode === "invisible" && <CaptchaDisclaimer />}
        </Wrapper>
    );
}

export default Verification;
